export default __webpack_public_path__ + "static/phone_booths-ca3822fbaf47196130b673767af32942.jpg";